import { Serializer, string } from '@niknevis/serializer'

import { BankAccountCollectionModel } from '@/modules/bank-account/models/bank-account-collection.model'

export class UserInfoSerializer extends Serializer<BankAccountCollectionModel> {

  @string().required()
  account_type: string

  @string().required()
  account_owner_name: string

  @string().required()
  card_number: number

  @string().required()
  sheba: number

  @string().required()
  bank_name: string

  @string().required()
  withdraw_period: string

  protected serialize(data: any): any {
    const backAccount = data.bank_account ? data.bank_account : data
    return {
      id: backAccount.id || 0,
      account_type: backAccount.account_type || 'natural-person',
      account_owner_name: backAccount.account_owner_name || '',
      card_number: backAccount.card_number || '',
      sheba: backAccount.sheba || '',
      bank_name: backAccount.bank_name || '',
      withdraw_period: backAccount.withdraw_period || ''
    }
  }
}
